import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'soporte',
  templateUrl: './soporte.component.html',
  styleUrls: ['./soporte.component.css']
})
export class SoporteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
